(ns app.strive-forms.subs
  (:require
   [re-posh.core :as re-posh]))

(re-posh/reg-sub
 ::form-filling-id
 (fn [_ _]
   {:type :query
    :query '[:find  ?fid
             :where [?fid :app/type :type/form-filling]]}))

(re-posh/reg-sub
 ::error-form-messages
 (fn [id _]
   {:type    :pull
    :pattern '[:db/id :form-filling/id :form-filling/error-form-messages]
    :id       15}))

(re-posh/reg-sub
 ::form-data
 (fn [id _]
   {:type    :pull
    :pattern '[:db/id :form-filling/id :form-filling/form-data :form-filling/display-fields
               :form-filling/prefilled-answer
               :form-filling/form-language 
:form-filling/language-direction
:form-filling/form-messages
               :form-filling/input-data :form-filling/hidden-fields
               :form-filling/logic-flow
               :form-filling/form-fields
               :form-filling/country-code
               :form-filling/icon
:form-filling/allowed-languages]
    :id       15}))
